<div class="form-group has-feedback">
  <input
    type="email"
    class="form-control"
    placeholder="Email"
    autocomplete="email"
    [formControl]="control"
    (keydown)="onEmailKeyDown($event)"
    (input)="onEmailInput($any($event.target).value)"
    (blur)="onEmailBlur()"
  />
  <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
</div>
